import {
  TextEditor,
  AttachmentIcon,
  TypeSelect,
  AssessmentButton,
  RightSidePanel,
  CheckboxRadio,
  Pagination,
  TemplateSearch,
  showToast,
} from "ui-components";
import "./TemplateBottomLeftSide.scss";
import { useTranslation } from "react-i18next";
import AnswerOptions from "../AnswerOptions/AnswerOptions";
import { setSessionStorageItem } from "../../../../../utils/SessionStorageMethod/setSessionStorageItem";
import { AssessmentJsonContext } from "../../../../../context/JsonContext/JsonContext";
import { useContext, useEffect, useState } from "react";
import { ImageUploader } from "../../../../../utils/Common/MediaUploader";
import {
  addDisableCss,
  calculateMinusAmount,
  generateUUID,
  isAnswerSetValid,
  minuteOptions,
} from "../../../../../utils/Common/Constant";
import CustomQuestionsView from "./CustomQuestionsView";
import {
  deleteCustomQuestion,
  getCustomQuestions,
} from "../../../../../service/DraftJson/DraftJson";
import Loader from "../../../../../components/Loader/Loader";
import DataNotAvailable from "../../../../../utils/DataNotFound/DataNotAvailable";
import useDebounce from "../../../../../utils/Hooks/useDebounce";

interface AnswerOptionState {
  Single: {
    id: string;
    label: string;
    selected: boolean;
    timeLimit?: undefined | number | string;
  }[];
  Multiple: {
    id: string;
    label: string;
    selected: boolean;
    timeLimit?: undefined | number | string;
  }[];
  Essay: string;
  Video: string;
}

export interface TemplateBottomLeftSideProps {
  setCreatedQuestionData: any;
  textEditorQuestion: string;
  attachedQuestionImage: any;
  setAttachedQuestionImage: any;
  setTextEditorQuestion: any;
  answerOptionState: AnswerOptionState;
  answerOptionSetState: any;
  defaultAnswerOption: AnswerOptionState;
  selectedType: any;
  setSelectedType: any;
  timeLimit: string | number | undefined;
  setTimeLimit: any;
  isQuestionAnsEdited: boolean;
  setIsQuestionAnsEdited: any;
  createdQuestionData?: any;
}

const TemplateBottomLeftSide: React.FunctionComponent<
  TemplateBottomLeftSideProps
> = ({
  setCreatedQuestionData,
  textEditorQuestion,
  setTextEditorQuestion,
  attachedQuestionImage,
  setAttachedQuestionImage,
  answerOptionState,
  answerOptionSetState,
  defaultAnswerOption,
  selectedType,
  setSelectedType,
  timeLimit,
  setTimeLimit,
  isQuestionAnsEdited,
  setIsQuestionAnsEdited,
  createdQuestionData,
}) => {
  const questionTypesArray = [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Single",
      value: "Single",
    },
    {
      label: "Multiple",
      value: "Multiple",
    },
    {
      label: "Video",
      value: "Video",
    },
    {
      label: "Essay",
      value: "Essay",
    },
  ];
  const [customSearchText, setCustomSearchText] = useState("");
  const customSearchTextDebounce = useDebounce(customSearchText, 500);
  const [selectedQuestionType, setSelectedQuestionType] = useState("All");
  const [originalCustomQuesData, setOriginalCustomQuesData] = useState([]);
  const [existingCustomQuestionsLoading, setExistingCustomQuestionsLoading] =
    useState(false);
  const existingCustomQuestions = originalCustomQuesData?.map((item: any) => {
    let answerSet;
    if (item.type === "Single") {
      answerSet = item.answerOptions
        ? item.answerOptions?.map((opt: any, index: any) => ({
            id: index === 0 ? "one" : `choice-${Math.random()}`,
            label: opt.option,
            selected:
              item.correctOptions?.some(
                (option: any) => option.option === opt.option,
              ) || false,
            image: null,
          }))
        : [];
    } else if (item.type === "Multiple") {
      answerSet = item.answerOptions
        ? item.answerOptions.map((opt: any, index: any) => ({
            id: index === 0 ? "checkbox one" : `choice-${Math.random()}`,
            label: opt.option,
            selected:
              item.correctOptions?.some(
                (option: any) => option.option === opt.option,
              ) || false,
          }))
        : [];
    } else if (item.type === "Essay" || item.type === "Video") {
      answerSet = item?.correctOptions;
    }
    return {
      id: item?.assessmentCustomQuestionId,
      question: item?.question,
      timeLimit: item?.timeLimit,
      answerSet,
      type: item?.type,
      reference: item?.assessmentCustomQuestionId,
    };
  });

  const textEditorLimit = 1001;
  const [textareaError, setTextareaError] = useState<string | null>(null);
  const [answerError, setAnswerError] = useState<string | null>(null);
  const [imageUploadError, setImageUploadError] = useState<boolean>(false);
  const [openCustomQuestionSideBar, setOpenCustomQuestionSideBar] =
    useState(false);
  const [countTextInEditor, setCountTextInEditor] =
    useState<number>(textEditorLimit);
  const [countManageFlag, setCountManageFlag] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const companyId = localStorage.getItem("companyId") ?? "";
  const { t } = useTranslation();
  const [checkedCustomQues, setCheckedCustomQues] = useState<any[]>([]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  useEffect(() => {
    if (openCustomQuestionSideBar) {
      getCustomQuestionsApi();
    }
  }, [
    openCustomQuestionSideBar,
    currentPage,
    customSearchTextDebounce,
    selectedQuestionType,
  ]);
  const getCustomQuestionsApi = async () => {
    setExistingCustomQuestionsLoading(true);
    try {
      const res = await getCustomQuestions(
        companyId,
        pageSize,
        currentPage,
        selectedQuestionType,
        customSearchText,
      );
      if (res?.status === 200) {
        setOriginalCustomQuesData(res?.data?.data);
        setTotalCount(res?.data?.totalCount);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setExistingCustomQuestionsLoading(false);
    }
  };
  const handleCheckboxChange = (
    item: (typeof existingCustomQuestions)[number],
  ) => {
    setCheckedCustomQues((prev) =>
      prev.some((q) => q.id === item?.id)
        ? prev.filter((q) => q.id !== item?.id)
        : [...prev, item],
    );
  };
  const handleCustomQuestionSelectSave = () => {
    setCreatedQuestionData((prev: any) => {
      const updatedData = [...prev, ...checkedCustomQues];
      setSessionStorageItem("createQuestionData", updatedData);
      return updatedData;
    });
    setCheckedCustomQues([]);
    setOpenCustomQuestionSideBar(false);
  };
  const { state } = useContext(AssessmentJsonContext) ?? {
    state: { renderJson: {} },
    dispatch: () => {},
  };
  // check text area valid
  const isTextareaValid = () => {
    return (
      textEditorQuestion.trim() !== "" &&
      textEditorQuestion.trim() !== "<p><br></p>"
    );
  };
  useEffect(() => {
    setAnswerError("");
  }, [selectedType?.type]);
  useEffect(() => {
    if (isTextareaValid()) {
      setTextareaError("");
    }
  }, [textEditorQuestion]);
  // handle add questions and answers
  const handleAdd = (data: any) => {
    if (!isTextareaValid()) {
      setTextareaError(t("REQUIRE.QUESTION_FIELD"));
    } else if (!isAnswerSetValid(data)) {
      setAnswerError(t("REQUIRE.ANSWER_FIELD"));
    } else if (
      (selectedType?.type === "Single" &&
        answerOptionState?.Single.length < 2) ||
      (selectedType?.type === "Multiple" &&
        answerOptionState?.Multiple.length < 2)
    ) {
      setAnswerError(t("ERROR.MINIMUM_TWO_ANS"));
    }
    if (
      isTextareaValid() &&
      isAnswerSetValid(data, true) &&
      calculateMinusAmount(countTextInEditor, textEditorLimit) >= 0
    ) {
      if (
        (selectedType?.type === "Single" &&
          answerOptionState?.Single.length >= 2) ||
        (selectedType?.type === "Multiple" &&
          answerOptionState?.Multiple.length >= 2) ||
        selectedType?.type === "Essay" ||
        selectedType?.type === "Video"
      ) {
        setCreatedQuestionData((prevData: any) => {
          const existingIndex = prevData.findIndex(
            (item: any) => item.id === selectedType.id,
          );
          if (existingIndex !== -1) {
            // If an object with the same id exists, update it
            const updatedData = [...prevData];
            const editedCustomObject = {
              id: Math.random(),
              question: textEditorQuestion,
              timeLimit: Number(timeLimit),
              image: attachedQuestionImage,
              reference: null,
              ...data,
            };
            const compareOldNewQuestionData =
              JSON.stringify(prevData[existingIndex]) ===
              JSON.stringify(editedCustomObject);
            if (compareOldNewQuestionData) {
              editedCustomObject.reference = selectedType.id;
              editedCustomObject.id = selectedType.id;
            }
            updatedData[existingIndex] = editedCustomObject;
            setSessionStorageItem("createQuestionData", updatedData);
            return updatedData;
          } else {
            // If an object with the same id doesn't exist, add a new object
            const updateData = [
              ...prevData,
              {
                id: Math.random(),
                question: textEditorQuestion,
                timeLimit: Number(timeLimit),
                image: attachedQuestionImage,
                ...data,
              },
            ];
            setSessionStorageItem("createQuestionData", [
              ...prevData,
              {
                id: Math.random(),
                question: textEditorQuestion,
                timeLimit: Number(timeLimit),
                image: attachedQuestionImage,
                ...data,
              },
            ]);
            return updateData;
          }
        });
        setTextEditorQuestion("");
        setSelectedType({ id: "", type: "Single" });
        answerOptionSetState(defaultAnswerOption);
        setTimeLimit(2);
        setAttachedQuestionImage();
        setCountManageFlag(false);
        setTextareaError(null);
        setAnswerError(null);
      }
    }
  };

  const textEditorHandleChange = (
    content: any,
    _delta: any,
    _source: any,
    editor: any,
  ) => {
    const currentLength = editor.getLength();
    setCountTextInEditor(currentLength);
    setCountManageFlag(true);
    setTextEditorQuestion(content);
  };

  // function to delete custom question from sidebar
  const onDeleteClick = async (id: string) => {
    const res = await deleteCustomQuestion(id);
    if (res?.status == 200) {
      showToast(res?.customMessage, "success");
      getCustomQuestionsApi();
    }
  };
  return (
    <div className="questionsSec">
      <div className="getCustomQuestionBtnSec">
        <AssessmentButton onClick={() => setOpenCustomQuestionSideBar(true)}>
          {t("GENERAL.SELECT_PREVIOUSLY_ADDED")}
        </AssessmentButton>
      </div>
      <div className="quillSec">
        <div
          className={`${addDisableCss(
            state?.renderJson?.scope?.createQuestion?.functionBehavior,
          )} row`}
        >
          <div className="col-md-9">
            <div className="quillContent">
              <h6 className="quillHeading">
                {t("CREATE_ASSESSMENT.CREATE_QUESTION")}
              </h6>
              <TextEditor
                value={textEditorQuestion}
                onChange={textEditorHandleChange}
                placeholder={t("CREATE_ASSESSMENT.CREATE_QUESTION_PLACEHOLDER")}
              />
              <div className="textEditorMsg">
                <p className="errorMessage">
                  {countTextInEditor > textEditorLimit && (
                    <>
                      {t("GENERAL.MUST_BE_LESS_THAN")} {textEditorLimit - 1}{" "}
                      {t("GENERAL.CHARACTERS")}
                    </>
                  )}
                </p>
                {(countManageFlag ? 1 : textEditorLimit) !=
                  countTextInEditor && (
                  <p className="limitMsg">
                    {calculateMinusAmount(countTextInEditor, textEditorLimit)}{" "}
                    {t("CREATE_ASSESSMENT.TEXT_EDITOR_LIMIT")}
                  </p>
                )}
              </div>

              {textareaError && (
                <div className="errorMessage">{textareaError}</div>
              )}
            </div>
          </div>
          <div className="col-md-3">
            <div className="timeLimit">
              <TypeSelect
                className="timeSelect"
                options={minuteOptions(t("GENERAL.MINUTE"))}
                label={t("GENERAL.TIME_LIMIT")}
                value={timeLimit}
                onChange={(e: any) => setTimeLimit(e)}
                loadingText={t("GENERAL.LOADING")}
              />
              <div className="attachedImgSec">
                <input
                  className="attachedInput"
                  type="file"
                  accept="image/png, image/jpeg, image/jpg, image/gif"
                  onChange={async (e: any) => {
                    const file = e.target.files[0];

                    // Check if the file type is an image
                    if (file && file.type.startsWith("image/")) {
                      setImageUploadError(false);
                      const ImageData = await ImageUploader(
                        e,
                        `interviews/${companyId}/question/${generateUUID()}`,
                      );
                      setAttachedQuestionImage(ImageData);
                      // Continue with your logic here
                    } else {
                      setImageUploadError(true);
                      // alert("Please upload an image file only.");
                    }
                  }}
                />
                <div className="attachedIconSec">
                  <p>{t("GENERAL.ATTACH_IMAGE")}</p>
                  <AttachmentIcon />
                </div>
              </div>
              {imageUploadError && (
                <p className="imageUploadError">
                  {t("CREATED_ASSESSMENT_IMAGE_ALLOWED")}
                </p>
              )}
              {attachedQuestionImage?.ImageUrl && (
                <div className="attachedImageParent">
                  <button
                    className="attachCrossBtn"
                    onClick={() => setAttachedQuestionImage(null)}
                  >
                    X
                  </button>
                  <div className="questionImageAttParent">
                    <img
                      className="attachedImageQuestion"
                      src={
                        (attachedQuestionImage?.ImageUrl as any) instanceof Blob
                          ? URL.createObjectURL(
                              attachedQuestionImage?.ImageUrl as any,
                            )
                          : attachedQuestionImage?.ImageUrl
                      }
                      alt="Attachment"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${addDisableCss(
          state?.renderJson?.scope?.answerQuestion?.functionBehavior,
        )} answerOptionSec`}
      >
        <h6 className="anserOtpHeading">
          {t("GENERAL.ANS_OPTIONS")} <span>({t("GENERAL.FILL_ANS")})</span>
        </h6>
        <AnswerOptions
          answerOptionState={answerOptionState}
          answerOptionSetState={answerOptionSetState}
          addBtnCallBack={handleAdd}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
          answerError={answerError}
          setAnswerError={setAnswerError}
          isQuestionAnsEdited={isQuestionAnsEdited}
          setIsQuestionAnsEdited={setIsQuestionAnsEdited}
        />
      </div>
      {openCustomQuestionSideBar && (
        <RightSidePanel
          show={true}
          handleClose={() => {
            setCheckedCustomQues([]);
            setOpenCustomQuestionSideBar(false);
          }}
          title={t("GENERAL.CUSTOM_QUESTION") + "s"}
          className="rightSidePanelSection customQuestionsPanel"
        >
          <div className="addBtn">
            <AssessmentButton onClick={handleCustomQuestionSelectSave}>
              {t("GENERAL.ADD_TO_ASSESSMENT")}
            </AssessmentButton>
          </div>
          <div className="customQuestionFilters">
            <TemplateSearch
              onChange={(e: string) => {
                setCustomSearchText(e);
                setCurrentPage(1);
              }}
              value={customSearchText}
              iconName="searchList"
              placeholder={t("GENERAL.SEARCH_EVENT")}
            />
            <TypeSelect
              onChange={(value: string) => setSelectedQuestionType(value)}
              options={questionTypesArray}
              value={selectedQuestionType}
              placeholder={t("CREATE_ASSESSMENT.QUESTION_TYPE")}
            />
          </div>
          <div className="existingCustomQSec">
            {existingCustomQuestionsLoading ? (
              <div className="d-flex minHeight100 align-items-center justify-content-center">
                <Loader />
              </div>
            ) : existingCustomQuestions?.length ? (
              existingCustomQuestions.map((item, index) => (
                <div className="setQues" key={item.id}>
                  <div className="numbersSec">
                    <CheckboxRadio
                      type="checkbox"
                      checked={
                        checkedCustomQues?.some((q) => q.id === item.id) ||
                        createdQuestionData?.some((q: any) => q.id === item.id)
                      }
                      onChange={() => handleCheckboxChange(item)}
                      additionalProps={{
                        disabled: createdQuestionData?.some(
                          (q: any) => q.id === item.id,
                        ),
                      }}
                    />
                  </div>
                  <div className="techQuestionsContent">
                    {CustomQuestionsView(item, index, onDeleteClick)}
                  </div>
                </div>
              ))
            ) : (
              <div className="noCustomQuestFound">
                <DataNotAvailable />
              </div>
            )}
            <div className="container">
              <div className="col-md-12">
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={totalCount > pageSize ? totalCount : 0}
                  pageSize={pageSize}
                  onPageChange={(page: number) => setCurrentPage(page)}
                  ofLabel={t("GENERAL.OF")}
                  resultLabel={t("GENERAL.RESULTS")}
                  setPageSize={setPageSize}
                />
              </div>
            </div>
          </div>
        </RightSidePanel>
      )}
    </div>
  );
};

export default TemplateBottomLeftSide;
